import { render, staticRenderFns } from "./sealPointsInput.vue?vue&type=template&id=2d24fc58&scoped=true"
import script from "./sealPointsInput.vue?vue&type=script&lang=js"
export * from "./sealPointsInput.vue?vue&type=script&lang=js"
import style0 from "./sealPointsInput.vue?vue&type=style&index=0&id=2d24fc58&prod&scoped=true&lang=less"
import style1 from "./sealPointsInput.vue?vue&type=style&index=1&id=2d24fc58&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d24fc58",
  null
  
)

export default component.exports